/* SR */
//ScrollReveal({ reset: true });
ScrollReveal().reveal('.welcome-block h1', { 
    origin: 'bottom',
  distance: '100%',
  duration: 800,
  //interval: 300,
     delay: 200 
});
ScrollReveal().reveal('.welcome-diagram-img img', { 
	origin: 'left',
  distance: '100%',
  duration: 1000,
  	 delay: 300
})
ScrollReveal().reveal('.welcome-address-img img', { 
	origin: 'bottom',
  distance: '100%',
  duration: 700,
  	 delay: 200
})
ScrollReveal().reveal('.welcome-block h4', { 
	origin: 'bottom',
  distance: '50%',
  duration: 500,
  	 delay: 200
})
ScrollReveal().reveal('.bldg-info-top', {
  origin: 'bottom',
  distance: '50%',
  duration: 1000,
  	 delay: 200
});
ScrollReveal().reveal('.bldg-info-btm', { 
  	origin: 'left',
  distance: '50%',
  duration: 800,
  	 delay: 300
})
ScrollReveal().reveal('.bldg-info-float-text', { 
  	origin: 'right',
  distance: '50%',
  duration: 800,
  	 delay: 200
})
ScrollReveal().reveal('.dtla-info h4', { 
  origin: 'bottom',
distance: '100%',
duration: 800,
   delay: 600
});
ScrollReveal().reveal('.dtla-info img', { 
	origin: 'left',
  distance: '80%',
  duration: 1100,
  	 delay: 300
})
ScrollReveal().reveal('.dtla-info h1', { 
  	origin: 'bottom',
  distance: '100%',
  interval: 300,
  duration: 1200,
  	 delay: 400
})
ScrollReveal().reveal('.dtla-info-hero-img1', { 
	origin: 'bottom',
  distance: '70%',
  duration: 1200,
  	 delay: 800
})
ScrollReveal().reveal('.dtla-info-hero-img2', { 
	origin: 'bottom',
  distance: '50%',
  duration: 900,
  	 delay: 400
})
ScrollReveal().reveal('.dtla-info-hero h4', { 
	origin: 'bottom',
  distance: '30%',
  duration: 300,
  	 delay: 200
})
ScrollReveal().reveal('.fabric-contact-info h1', { 
  	origin: 'bottom',
  distance: '100%',
  duration: 900,
  	 delay: 300
})
ScrollReveal().reveal('.fabric-contact-hp', { 
  origin: 'bottom',
distance: '100%',
duration: 700,
   delay: 400
})
ScrollReveal().reveal('.template-page .hero-content-headline', { 
  origin: 'bottom',
distance: '100%',
duration: 600,
   delay: 300
})
ScrollReveal().reveal('.hero-content-text', { 
  origin: 'bottom',
distance: '60%',
duration: 1100,
   delay: 300
})
ScrollReveal().reveal('.template-page .hero-content-bottom', { 
duration: 1100,
   delay: 500
})
ScrollReveal().reveal('.template-page .hhc-contact-bar', { 
  origin: 'bottom',
  distance: '100%', 
  duration: 700,
     delay: 200
})
ScrollReveal().reveal('.feature-gallery__content p', {
   origin: 'bottom',
 distance: '100%', 
 duration: 800,
 interval: 300,
    delay: 300
})
ScrollReveal().reveal('.cre-cov-top h1', {
  origin: 'bottom',
distance: '100%', 
duration: 800,
   delay: 200
})
ScrollReveal().reveal('p.cre-cov-title', { 
duration: 800,
interval: 200,
   delay: 400
})
ScrollReveal().reveal('p.cre-cov-items', { 
  duration: 800,
  interval: 300,
     delay: 400
  })



